import { SEGMENTS, INSIGHT_SEGMENTS_INSIGHT_DROPDOWNS } from '@model';
import { INSIGHT_SEGMENTS, INSIGHTS_ORDER_ARRAY } from './insights';
import { exchangeKeyVInObj } from '@utils/common';

export const USER_PERMISSION_MODEL = {
  HOME: 'Home',
  ANALYSIS: SEGMENTS,
  INSIGHT: INSIGHT_SEGMENTS,
  QUESTIONNAIRE: {
    // welcome: 'welcome',
    complexity: 'complexity',
  },
};

export const USER_ROLE_MODEL = {
  CLIENT: 'client',
  INTERNAL: 'internal',
  ADMIN: 'admin',
};

export const DEFALUT_PERMISSION_SECTION = {
  HOME: 'Home',
  PEOJECT_LIST: 'projectList',
  ANALYSIS: 'analysis',
  INSIGHT: 'insight',
  QUESTIONNAIRE: 'questionnaire',
  STATUS_REPORTING: 'statusReporting',
  SYNERGY_TRACKER: 'synergyTracker',
  TSA_ACCELERATOR: 'tsaAccelerator',
  WORKFORCE_ARCHITECT: 'workforceArchitect',
};

export const DEFAULT_PERMISSION_SECTION_VALUES = Object.values(
  DEFALUT_PERMISSION_SECTION,
);

export const exchangeDefaultModule = exchangeKeyVInObj(
  DEFALUT_PERMISSION_SECTION,
);

const AnalysisTreeMap = Object.keys(SEGMENTS).map((s) => ({
  title: SEGMENTS[s],
  key: s,
}));

export const AnalysisMap = Object.keys(SEGMENTS).map((s) => ({
  label: SEGMENTS[s],
  value: s,
}));

const InsightTreeMap = INSIGHTS_ORDER_ARRAY.map((s, i) => ({
  title: INSIGHT_SEGMENTS_INSIGHT_DROPDOWNS[s],
  key: s,
}));

export const InsightMap = INSIGHTS_ORDER_ARRAY.map((s, i) => ({
  label: INSIGHT_SEGMENTS_INSIGHT_DROPDOWNS[s],
  value: s,
}));

export const AnalysisPermissionKeys = Object.keys(SEGMENTS);

export const InsightsPermissionKeys = INSIGHTS_ORDER_ARRAY;

export const LEFT_PERMISSION_TREE = [
  {
    title: 'Project Home',
    key: 'Home',
    disabled: true,
    checked: true,
  },
  { title: 'Analysis', key: 'Analysis', children: AnalysisTreeMap },
];
export const RIGHT_PERMISSION_TREE = [
  {
    title: 'Insight',
    key: 'insight-all',
    children: [...InsightTreeMap],
  },
  {
    title: 'Questionnaire',
    key: 'Questionnaire',
    children: [
      // {
      //   title: 'Diagnostic Questionnaire',
      //   key: 'welcome',
      // },
      {
        title: 'Overall Deal Complexity',
        key: 'complexity',
      },
    ],
  },
];

export const PERMISSION_OPTION = {
  [DEFALUT_PERMISSION_SECTION.HOME]: [{ label: 'Project Home', value: 'Home' }],
  [DEFALUT_PERMISSION_SECTION.PEOJECT_LIST]: [
    { label: 'Project List', value: 'projectList' },
  ],
  [DEFALUT_PERMISSION_SECTION.ANALYSIS]: AnalysisMap,
  [DEFALUT_PERMISSION_SECTION.INSIGHT]: InsightMap,
  [DEFALUT_PERMISSION_SECTION.QUESTIONNAIRE]: [
    {
      label: 'Overall Deal Complexity',
      value: 'complexity',
    },
  ],
  [DEFALUT_PERMISSION_SECTION.STATUS_REPORTING]: [
    {
      label: 'Status Reporting',
      value: DEFALUT_PERMISSION_SECTION.STATUS_REPORTING,
    },
  ],
  [DEFALUT_PERMISSION_SECTION.SYNERGY_TRACKER]: [
    {
      label: 'Synergy Tracker',
      value: DEFALUT_PERMISSION_SECTION.SYNERGY_TRACKER,
    },
  ],
  [DEFALUT_PERMISSION_SECTION.TSA_ACCELERATOR]: [
    {
      label: 'TSA Accelerator',
      value: DEFALUT_PERMISSION_SECTION.TSA_ACCELERATOR,
    },
  ],
  [DEFALUT_PERMISSION_SECTION.WORKFORCE_ARCHITECT]: [
    {
      label: 'Workforce Architect',
      value: DEFALUT_PERMISSION_SECTION.WORKFORCE_ARCHITECT,
    },
  ],
};
